import { useEffect, useMemo } from 'react';
import { getSessionToken } from '@room/frontend-sdk';
import { LoadingScreen, useSession, getLoginRedirectUrl, shouldRedirectToLogin } from '@room/shared-ui';
import { HomePage } from './pages/HomePage';
import './App.css';

export function App() {
  const { isAuthenticated, isLoading, hasCheckedSession, error, refresh } = useSession();
  const returnTo = useMemo(() => window.location.pathname + window.location.search, []);
  const debugDetails = (
    <ul style={{ margin: 0, paddingLeft: '16px' }}>
      <li>{`hasToken: ${Boolean(getSessionToken())}`}</li>
      <li>{`isLoading: ${isLoading}`}</li>
      <li>{`hasCheckedSession: ${hasCheckedSession}`}</li>
      <li>{`isAuthenticated: ${isAuthenticated}`}</li>
      {error ? <li>{`error: ${error.message}`}</li> : null}
    </ul>
  );

  useEffect(() => {
    if (hasCheckedSession && !isLoading && !isAuthenticated) {
      if (shouldRedirectToLogin(window.location.pathname)) {
        window.location.replace(getLoginRedirectUrl(returnTo));
      }
    }
  }, [hasCheckedSession, isAuthenticated, isLoading, returnTo]);

  if (!hasCheckedSession || isLoading) {
    return (
      <LoadingScreen
        title="Loading Home"
        message="Checking your session before showing the home screen."
        details={debugDetails}
      />
    );
  }

  if (!isAuthenticated) {
    return (
      <LoadingScreen
        title="Redirecting"
        message="Taking you to the login screen."
        details={debugDetails}
        actions={
          error ? (
            <button
              type="button"
              onClick={() => refresh()}
              style={{
                padding: '8px 12px',
                borderRadius: '6px',
                border: '1px solid #d1d5db',
                background: '#fff',
                cursor: 'pointer',
              }}
            >
              Retry session check
            </button>
          ) : null
        }
      />
    );
  }

  return <HomePage />;
}
